import React from 'react';
import { Colors } from '../colors/colors';
import { ICONS_MAP } from '../icons/icons';


const Icon = ({
	name,
	size = 16,
	color = Colors.darkBlue,
	cursor = 'pointer',
	onClick = () => { },
	rotate,
	style = {},
	spin = false,
}) => {

	const SvgIcon = ICONS_MAP[name];
	const basicStyle = {
		transform: rotate ? 'rotate(180deg)' : '',
		color: color,
		fontWeight: 'bold',
		cursor: cursor,
		fontSize: `${size}px`,
		transition: '0.3s all',
		animation: spin ? 'spin 1s linear infinite' : 'none',
		...style,
	}


	if (SvgIcon) {
		return <SvgIcon width={size} height={size} style={{ ...basicStyle, ...style }} onClick={onClick} />;
	}

	return (
		<i
			className={name}
			style={{
				...basicStyle,
				...style,
			}}
			onClick={() => onClick()}
		/>
	);
};

export default Icon;
